if (!customElements.get('rich-text-read-more')) {
  customElements.define(
    'rich-text-read-more',
    class RichTextReadMore extends HTMLElement {
      constructor() {
        super();
        this._onClick = this._onClick.bind(this);
      }

      connectedCallback() {
        this._content = this.querySelector('.rich-text__read-more-content');
        this._btn = this.querySelector('.rich-text__read-more-btn');
        this._labelMore = this.dataset.labelMore || 'Read more';
        this._labelLess = this.dataset.labelLess || 'Read less';

        let collapsedHeight = parseInt(this.dataset.collapsedHeight, 10);
        if (isNaN(collapsedHeight) || collapsedHeight <= 0) collapsedHeight = 120;
        this._collapsedHeight = collapsedHeight;

        this._content.style.maxHeight = `${this._collapsedHeight}px`;

        if (this._content.scrollHeight <= this._collapsedHeight) {
          this._btn.hidden = true;
          return;
        }

        this._btn.addEventListener('click', this._onClick);
      }

      disconnectedCallback() {
        if (this._btn) this._btn.removeEventListener('click', this._onClick);
      }

      _onClick() {
        const expanded = this._btn.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          this._content.style.maxHeight = `${this._collapsedHeight}px`;
          this._btn.setAttribute('aria-expanded', 'false');
          this._btn.querySelector('span').textContent = this._labelMore;
        } else {
          this._content.style.maxHeight = `${this._content.scrollHeight}px`;
          this._btn.setAttribute('aria-expanded', 'true');
          this._btn.querySelector('span').textContent = this._labelLess;
        }
      }
    }
  );
}
